import React, { useContext, useMemo, useState } from 'react'
import { AuthContext } from '../../../../../../context/auth.context'
import { useApiFormNodeCourse, useApiListNodeCourseCategory } from '../../../../../../api-new/state/content'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconCopy } from '../../../../../../shared/icon/icon'
import { LoginSysAdmin } from '../../../../../../role/components/login-sys-admin'
import { CourseMenu } from '../../common/menu/node-actions'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { NodeCaffeine } from '../../common/shared/node-caffeine'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleOrgaizationSelect } from '../../../../../../shared/form-simple/form-organization-select-filter'
import { FormSimpleCategoryOrganizationSelectFilter } from '../../../../../../shared/form-simple/form-category-organization-select-filter'
import { useLoad } from '../../../../../../shared/hooks/load'
import { useTransferContext } from '../../../../../../shared/transfer/transfer-provider'
import { TransferCopyNodeStatus } from '../../../../../../shared/transfer/components/transfer-copy-node-status'
import { useTransferComplete, useTransferNodeCopyAllowGoto } from '../../../../../../shared/transfer/hooks/transfer-data'
import { useHistory } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { useDataContext } from '../data-context'
import { pathNodeContent } from '../../common/shared/path-node-content'

export const NodeCourseCopy = ({ nodeID, parentURL }) => {
  const authContext = useContext(AuthContext)

  const apiFormNodeCourse = useApiFormNodeCourse()

  const [organizationID, updateOrganizationID] = useState(null)

  useLoad(
    () => {
      authContext.state.organizationID && updateOrganizationID(authContext.state.organizationID)
    },
    [authContext.state.organizationID]
  )

  const title = useMemo(() => `copy ${apiFormNodeCourse.form.name}`, [apiFormNodeCourse.form.name])

  const handleMatch = () => apiFormNodeCourse.get(nodeID)

  const HeaderMenu = () => <CourseMenu place="header" url={parentURL} node={apiFormNodeCourse.form} nodeID={nodeID} />

  const handleOrgChange = value => {
    if (value) {
      updateOrganizationID(value.id)
    } else {
      updateOrganizationID(null)
    }
  }

  ///////////////

  const history = useHistory()

  const dataContext = useDataContext()
  const transferContext = useTransferContext()

  const transferID = useMemo(() => `course-copy-${nodeID}`, [nodeID])

  const transfer = useMemo(() => transferContext.items[transferID] || null, [transferContext.items, transferID])

  const active = useMemo(() => !!transfer, [transfer])

  const allowGoto = useTransferNodeCopyAllowGoto(transfer, authContext.state.organizationID)

  useTransferComplete(transfer, () => {
    dataContext.reload()
  })

  const handleSubmit = async data => {
    if (data.destParentID === -1) {
      data.destParentID = null
    }

    const transfer = transferContext.nodeCopyCourse(transferID, data.destName, history.location.pathname)
    transfer.start(data)
  }

  const handleGoTo = nodeID => {
    let nodes = [...dataContext.categories, ...dataContext.courses]
    let path = pathNodeContent(nodes, nodeID)
    history.replace(path)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconCopy} text="copy course" onMatch={handleMatch}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <NodeCaffeine node={apiFormNodeCourse.form}>
            <FormSimple disabled={active} onSubmit={handleSubmit}>
              <FormSimpleHiddenNumber name="srcNodeID" value={nodeID} required />

              <LoginSysAdmin>
                <FormSimpleOrgaizationSelect name="organizationID" defaultValue={authContext.state.organizationID} required onChange={handleOrgChange} />
              </LoginSysAdmin>

              {organizationID &&
                <FormSimpleCategoryOrganizationSelectFilter
                  name="destParentID"
                  label="category"
                  rootName="CONTENT"
                  organizationID={organizationID}
                  useApiListCategory={useApiListNodeCourseCategory}
                  required
                />}

              <FormSimpleText name="destName" label="name" defaultValue={apiFormNodeCourse.form.name} required />
              <FormSimpleSubmitEdit text="copy course" backURL={parentURL} />
            </FormSimple>

            <TransferCopyNodeStatus transfer={transfer} allowGoto={allowGoto} gotoText="view new course" onGoTo={handleGoTo} />
          </NodeCaffeine>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
